import React, { useState } from "react";
import { motion } from "framer-motion";
import CustomAction from "../../../../controls/CustomAction";
import { TbCircleDotFilled } from "react-icons/tb";
import checkOption from "../../../../../Assets/check.png";
import notAllowedOption from "../../../../../Assets/not-allowed.png";
import otherOption from "../../../../../Assets/other-opt.png";
import { Textarea } from "@mui/joy";

export default function VaccineHistory({
  mainColor,
  handleNextStepPC,
  tripCountries,
  tripSelections,
  setTripSelections,
}) {
  const [selectedItem, setSelectedItem] = useState([]);

  const options = [
    {
      iconSrc: checkOption,
      title: "Yes, but not sure which ones",
    },
    {
      iconSrc: checkOption,
      title: "Yes, and I know which ones",
    },
    {
      iconSrc: notAllowedOption,
      title: "No, never",
    },
    {
      iconSrc: otherOption,
      title: "I have no idea!",
    },
  ];

  const handleOptionsClick = (option) => {
    setSelectedItem(option.title);
  };

  const handleContinue = () => {
    handleNextStepPC();
  };

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 100, delay: 0.5 }}
      exit={{ y: 50, opacity: 0 }}
      className="bf-content-wrapper pc-vaccine-history"
    >
      <div className="bf-content-header">
        <h2 className="bf-title" style={{ color: mainColor }}>
          Vaccine History
        </h2>
        <p className="bf-subtitle">
          Why we ask: If you've had certain vaccinations before, you may not
          need boosters or additional shots.
        </p>
      </div>

      <div className="bf-content-body">
        <div className="body-container">
          <div className="options-wrapper">
            {options.map((option, index) => (
              <div
                className={`options-box ${
                  selectedItem === option.title ? "selected" : ""
                }`}
                key={index}
                style={{
                  border: `1px solid ${
                    selectedItem === option.title ? mainColor : "#cecece"
                  }`,
                }}
                onClick={() => handleOptionsClick(option)}
              >
                <div>
                  <div>
                    <img src={option.iconSrc} alt="icon" />
                  </div>

                  <p className="question">{option.title}</p>
                </div>

                {selectedItem === option.title ? (
                  <TbCircleDotFilled
                    className="checkmark"
                    color={mainColor}
                    size={22}
                  />
                ) : (
                  <div className="empty-circle"></div>
                )}
              </div>
            ))}
          </div>
          <p className="optional">Optional</p>
          <Textarea
            placeholder="You can write your comments here..."
            className="vaccine-history-textarea"
            minRows={3}
            onChange={(e) => {}}
          />
        </div>
        <CustomAction mainColor={mainColor} text={"Continue"} action={handleContinue} />
      </div>
    </motion.div>
  );
}
